import React from 'react';
import { ReviewDayStat } from '../types/stats';

interface ActivityChartProps {
  data: ReviewDayStat[];
  unitLabel?: string;
  activityLabel?: string;
}

export const ActivityChart: React.FC<ActivityChartProps> = ({ data, unitLabel = '次', activityLabel = '评分' }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-center py-8 text-sm text-slate-400">
        暂无复习活动记录
      </div>
    );
  }

  // Take the most recent 14-21 days if more
  const displayData = data.slice(-21);
  const maxCount = Math.max(...displayData.map((d) => d.count), 5);

  const height = 120;
  const barWidth = 14;
  const gap = 8;
  const totalWidth = displayData.length * (barWidth + gap);

  return (
    <div className="overflow-x-auto">
      <div className="min-w-fit">
        <svg height={height + 25} width={Math.max(totalWidth + 20, 300)} className="overflow-visible">
          {displayData.map((d, idx) => {
            const barHeight = (d.count / maxCount) * height;
            const x = 10 + idx * (barWidth + gap);
            const y = height - barHeight;
            const dateObj = new Date(d.day);
            const label = isNaN(dateObj.getTime())
              ? d.day.slice(-5)
              : `${dateObj.getMonth() + 1}/${dateObj.getDate()}`;

            return (
              <g key={d.day} className="group">
                {/* Background column hover guide */}
                <rect
                  x={x - 2}
                  y={0}
                  width={barWidth + 4}
                  height={height}
                  fill="transparent"
                  className="hover:fill-slate-100 transition-colors cursor-pointer"
                />
                {/* Active Bar */}
                <rect
                  x={x}
                  y={y}
                  width={barWidth}
                  height={Math.max(barHeight, 2)}
                  rx={3}
                  className={`${
                    d.count > 0 ? 'fill-emerald-500 hover:fill-emerald-600' : 'fill-slate-200'
                  } transition-all`}
                >
                  <title>{`${d.day}: ${activityLabel} ${d.count} ${unitLabel}`}</title>
                </rect>
                {/* Count tooltip / text if count > 0 */}
                {d.count > 0 && (
                  <text
                    x={x + barWidth / 2}
                    y={y - 4}
                    textAnchor="middle"
                    className="text-[9px] font-mono fill-slate-500 opacity-0 group-hover:opacity-100 transition-opacity"
                  >
                    {d.count}
                  </text>
                )}
                {/* Date Label */}
                <text
                  x={x + barWidth / 2}
                  y={height + 15}
                  textAnchor="middle"
                  className="text-[10px] fill-slate-400 font-mono"
                >
                  {label}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
};
